import { useEffect, useState } from 'react'

const getDimensions = ref => ({
  width: ref?.current?.offsetWidth,
  height: ref?.current?.offsetHeight
})

const useContainerSize = myRef => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions(myRef))
    }

    if (myRef.current) {
      setDimensions(getDimensions(myRef))
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [myRef])

  return dimensions
}

export default useContainerSize
